export default __webpack_public_path__ + "static/media/other.f5c2eebb.svg";